/* ------------------------------------------ Auth State Structure ------------------------------------------ */

import { AuthState, IAuthState } from '@core/api/data-access';
import {environment, isDevMode} from '@shared-types';

/* ------------------------------------------- Auth Initial State ------------------------------------------- */

export const authInitialState: IAuthState = {
	// Authorization Tokens:
	accessToken: '',
	refreshToken: '',

	// Active Company Details:
	tenant: isDevMode() ? environment.company : window.location.hostname.split('.')[0],
	apiUri: '',

	// Authorization Indicators:
	authLoad: {
		inLoginProcess: false,
		loggedIn: false,
		inRefreshProcess: false,
		inLogoutProcess: false,
	},
	authTimings: null,
	rememberMe: false,
	permissions: [],
};

export const authStoreInitialState: AuthState = {
	...authInitialState,
};
